import { Dropdown, message } from 'antd';
import {
  DatabaseOutlined,
  ApiOutlined,
  LinkOutlined,
  CloudSyncOutlined,
  AimOutlined,
} from '@ant-design/icons';
import useEditorUiStore from '../../../stores/editorUiStore';
import useCalibrationStore from '../../../stores/calibrationStore';

export default function DataMenu() {
  const setActivePanel = useEditorUiStore((s) => s.setActivePanel);

  const handleMenuClick = (e: { key: string }) => {
    switch (e.key) {
      case 'iot':
        setActivePanel('iot');
        break;
      case 'datasource':
        setActivePanel('data');
        break;
      case 'binding':
        setActivePanel('data');
        break;
      case 'sync':
        message.info('云同步');
        break;
      case 'calibrate':
        useCalibrationStore.getState().open();
        break;
      default:
        break;
    }
  };

  const menuItems = [
    {
      key: 'iot',
      icon: <ApiOutlined />,
      label: 'IoT设备管理',
    },
    {
      key: 'datasource',
      icon: <DatabaseOutlined />,
      label: '数据源配置',
    },
    {
      key: 'binding',
      icon: <LinkOutlined />,
      label: '数据绑定',
    },
    {
      key: 'calibrate',
      icon: <AimOutlined />,
      label: '相机标定（2D→3D）',
    },
    {
      type: 'divider' as const,
    },
    {
      key: 'sync',
      icon: <CloudSyncOutlined />,
      label: '云同步',
    },
  ];

  return (
    <Dropdown
      menu={{ items: menuItems, onClick: handleMenuClick }}
      trigger={['click']}
    >
      <span style={{ cursor: 'pointer', padding: '0 8px' }}>
        数据▼
      </span>
    </Dropdown>
  );
}
